import React, { useState } from "react";
import { Facebook, Instagram, Youtube, Share2, X } from "lucide-react";
import { useSite } from "@/context/SiteContext";
import { WhatsAppIcon, TikTokIcon, XIcon } from "@/components/site/Icons";

const NETS = [
  { k: "facebook", Icon: Facebook, bg: "#1877F2", label: "Facebook" },
  { k: "instagram", Icon: Instagram, bg: "#E1306C", label: "Instagram" },
  { k: "tiktok", Icon: TikTokIcon, bg: "#111111", label: "TikTok" },
  { k: "youtube", Icon: Youtube, bg: "#FF0000", label: "YouTube" },
  { k: "x", Icon: XIcon, bg: "#000000", label: "X" },
];

export default function FloatingButtons() {
  const { settings, t } = useSite();
  const [open, setOpen] = useState(false);
  if (!settings) return null;
  const nets = NETS.filter((n) => settings.social?.[n.k]);

  return (
    <>
      {/* Social floating (left) */}
      {nets.length > 0 && settings.show_social_float !== false && (
        <div className="fixed left-4 bottom-6 z-40 flex flex-col-reverse items-center gap-3" data-testid="floating-social">
          <button
            onClick={() => setOpen(!open)}
            data-testid="floating-social-toggle"
            aria-label={t("followUs")}
            className="w-12 h-12 rounded-full brand-bg text-white shadow-lg flex items-center justify-center hover:scale-105 transition-transform duration-200"
          >
            {open ? <X className="w-5 h-5" /> : <Share2 className="w-5 h-5" />}
          </button>
          {nets.map((n, i) => (
            <a
              key={n.k}
              href={settings.social[n.k]}
              target="_blank"
              rel="noreferrer"
              aria-label={n.label}
              data-testid={`floating-social-${n.k}`}
              style={{ backgroundColor: n.bg, transitionDelay: open ? `${i * 50}ms` : "0ms" }}
              className={`group relative w-11 h-11 rounded-full text-white shadow-md flex items-center justify-center transition-[opacity,transform] duration-300 ${open ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4 pointer-events-none"}`}
            >
              <n.Icon className="w-5 h-5" />
              <span className="absolute left-14 whitespace-nowrap rounded-md bg-gray-900 text-white text-xs px-2 py-1 opacity-0 group-hover:opacity-100 transition-opacity">{n.label}</span>
            </a>
          ))}
        </div>
      )}
      {/* WhatsApp (right) */}
      {settings.whatsapp && settings.show_whatsapp_float !== false && (
        <a
          href={`https://wa.me/${settings.whatsapp}${settings.whatsapp_message ? `?text=${encodeURIComponent(settings.whatsapp_message)}` : ""}`}
          target="_blank"
          rel="noreferrer"
          aria-label="WhatsApp"
          data-testid="floating-whatsapp"
          className="pulse-ring fixed right-5 bottom-6 z-40 w-14 h-14 rounded-full bg-[#25d366] text-white shadow-xl flex items-center justify-center hover:scale-105 transition-transform duration-200 isolate"
        >
          <WhatsAppIcon className="w-8 h-8" />
        </a>
      )}
    </>
  );
}
